import ReactGA from "react-ga4";
import { canSendGaEvents } from "src/libs/analytics";

export const trackButtonClick = (label: string) => {
  if (!canSendGaEvents()) {
    return;
  }
  ReactGA.event({
    category: "Button",
    action: "Click",
    label: label,
  });
};
